import React, { useState } from 'react';
import { Row, Col, Button, Alert, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import * as Constants from '../../../../../helper/constants';
import dynamicUrl from '../../../../../helper/dynamicUrls';
import MESSAGES from '../../../../../helper/messages';
import { labelTexts } from '../../../../../util/names';
import { SessionStorage } from '../../../../../util/SessionStorage';
import { defaultPostApi } from '../../bgv-api/BgvApi';
import { bgvStatusV2 } from '../../bgv-api/dbMapping';
import { Formik } from 'formik';
import { isEmptyArray } from '../../../../../util/utils';
import { bgvAlerts } from '../../bgv-api/bgvAlerts';

const ClearInsufficiency = (props) => {
  const { caseId, component, caseComponentData, subComponent = '', reloadData = () => { }, setIgnoreReduxData = () => { }, setLoadStatus = () => { } } = props;
  const [isEmailModalOne, setIsEmailModalOne] = useState();
  const [btnLoader, setBtnLoader] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [currentInsuffType, setCurrentInsuffType] = useState('regular');

  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      icon: alert.type
    });
  };

  const handleIntiateMail = (insuffType = 'regular') => {
    setCurrentInsuffType(insuffType);
    setIsEmailModalOne(true)
    setEmailSent(false);
  }

  const getComponentStatus = () => {
    // Debug logging for Gap Verification
    if (component === "GapVerification") {
      console.log("=== ClearInsufficiency Debug (GapVerification) ===");
      console.log("subComponent:", subComponent);
      console.log("caseComponentData:", caseComponentData);
      console.log("evidenceKey:", `gapVerificationEvidence${subComponent}`);
      console.log("evidenceObject:", caseComponentData?.[`gapVerificationEvidence${subComponent}`]);
      console.log("status:", caseComponentData?.[`gapVerificationEvidence${subComponent}`]?.gapVerificationStatus);
      console.log("bgvStatusV2.Insufficient:", bgvStatusV2.Insufficient);
      console.log("===================================");
    }

    switch (component) {
      case "Address":
        if (subComponent === "permanentAddress") {
          return caseComponentData?.permanentAddressEvidence?.addressStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "currentAddress") {
          return caseComponentData?.currentAddressEvidence?.addressStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "intermediateAddressOne") {
          return caseComponentData?.intermediateAddressOneEvidence?.addressStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "intermediateAddressTwo") {
          return caseComponentData?.intermediateAddressTwoEvidence?.addressStatus === bgvStatusV2.Insufficient;
        }
        return false;

      case "Education":
        if (subComponent === "One") {
          return caseComponentData?.educationEvidenceOne?.educationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Two") {
          return caseComponentData?.educationEvidenceTwo?.educationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Three") {
          return caseComponentData?.educationEvidenceThree?.educationStatus === bgvStatusV2.Insufficient;
        }
        return false;

      case "Employment":
        if (subComponent === "One") {
          return caseComponentData?.employmentEvidenceOne?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Two") {
          return caseComponentData?.employmentEvidenceTwo?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Three") {
          return caseComponentData?.employmentEvidenceThree?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Four") {
          return caseComponentData?.employmentEvidenceFour?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Five") {
          return caseComponentData?.employmentEvidenceFive?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Six") {
          return caseComponentData?.employmentEvidenceSix?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Seven") {
          return caseComponentData?.employmentEvidenceSeven?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Eight") {
          return caseComponentData?.employmentEvidenceEight?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Nine") {
          return caseComponentData?.employmentEvidenceNine?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Ten") {
          return caseComponentData?.employmentEvidenceTen?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Eleven") {
          return caseComponentData?.employmentEvidenceEleven?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Twelve") {
          return caseComponentData?.employmentEvidenceTwelve?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Thirteen") {
          return caseComponentData?.employmentEvidenceThirteen?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Fourteen") {
          return caseComponentData?.employmentEvidenceFourteen?.employmentStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Fifteen") {
          return caseComponentData?.employmentEvidenceFifteen?.employmentStatus === bgvStatusV2.Insufficient;
        }
        return false;

      case "Criminal":
        if (subComponent === "current") {
          return caseComponentData?.addressEvidence?.currStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "permanent") {
          return caseComponentData?.addressEvidence?.permStatus === bgvStatusV2.Insufficient;
        }
        return false;

      case "Reference":
        if (subComponent === "One") {
          return caseComponentData?.referenceEvidenceOne?.referenceStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Two") {
          return caseComponentData?.referenceEvidenceTwo?.referenceStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Three") {
          return caseComponentData?.referenceEvidenceThree?.referenceStatus === bgvStatusV2.Insufficient;
        }
        return false;

      case "DatabaseCheck":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "CibilCheck":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "CreditCheck":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "CvValidation":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "DrugTest":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "OFAC":     // newly added
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "GapVerification":
        if (subComponent === "One") {
          return caseComponentData?.gapVerificationEvidenceOne?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Two") {
          return caseComponentData?.gapVerificationEvidenceTwo?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Three") {
          return caseComponentData?.gapVerificationEvidenceThree?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Four") {
          return caseComponentData?.gapVerificationEvidenceFour?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Five") {
          return caseComponentData?.gapVerificationEvidenceFive?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Six") {
          return caseComponentData?.gapVerificationEvidenceSix?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Seven") {
          return caseComponentData?.gapVerificationEvidenceSeven?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Eight") {
          return caseComponentData?.gapVerificationEvidenceEight?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Nine") {
          return caseComponentData?.gapVerificationEvidenceNine?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        if (subComponent === "Ten") {
          return caseComponentData?.gapVerificationEvidenceTen?.gapVerificationStatus === bgvStatusV2.Insufficient;
        }
        // if (subComponent === "Eleven") {
        //   return caseComponentData?.gapVerificationEvidenceEleven?.gapVerificationStatus === bgvStatusV2.Insufficient;
        // }
        // if (subComponent === "Twelve") {
        //   return caseComponentData?.gapVerificationEvidenceTwelve?.gapVerificationStatus === bgvStatusV2.Insufficient;
        // }
        // if (subComponent === "Thirteen") {
        //   return caseComponentData?.gapVerificationEvidenceThirteen?.gapVerificationStatus === bgvStatusV2.Insufficient;
        // }
        // if (subComponent === "Fourteen") {
        //   return caseComponentData?.gapVerificationEvidenceFourteen?.gapVerificationStatus === bgvStatusV2.Insufficient;
        // }
        // if (subComponent === "Fifteen") {
        //   return caseComponentData?.gapVerificationEvidenceFifteen?.gapVerificationStatus === bgvStatusV2.Insufficient;
        // }
        return false;

      case "Identification":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "CompanyCheck":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "DirectorshipCheck":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "PoliceVerification":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "SocialMedia":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "UanCheck":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      case "BankStatement":
        return caseComponentData.componentStatus === bgvStatusV2.Insufficient;

      default:
        return false;
    }
  };

  // Check if regular (primary) insufficiency is raised for this sub-component
  const hasRegularInsufficiency = () => {
    if (component === 'Employment' && subComponent) {
      return !!caseComponentData?.[`employmentDetail${subComponent}`]?.primaryInsufficiency;
    }
    if (component === 'Education' && subComponent) {
      return !!caseComponentData?.[`educationDetail${subComponent}`]?.primaryInsufficiency;
    }
    // For non-Employment/Education components, fall back to getComponentStatus
    return getComponentStatus();
  };

  // Check if additional cost insufficiency is raised for this sub-component
  const hasAdditionalCostInsufficiency = () => {
    if (component === 'Employment' && subComponent) {
      return !!caseComponentData?.[`employmentDetail${subComponent}`]?.additionalCostInsufficiency;
    }
    if (component === 'Education' && subComponent) {
      return !!caseComponentData?.[`educationDetail${subComponent}`]?.additionalCostInsufficiency;
    }
    return false;
  };


  return (
    <React.Fragment>
      {SessionStorage.getItem("user_category") === Constants.PortalUserRoles.CstSupervisor || SessionStorage.getItem("user_category") === Constants.PortalUserRoles.CstUser ?
        <>
          <Button
            disabled={!hasRegularInsufficiency()}
            className="btn-block"
            color="warning"
            size="large"
            variant="warning"
            onClick={() => handleIntiateMail('regular')}
          >
            {labelTexts.ClearInsufficiencyButton}
          </Button>
          {(component === 'Employment' || component === 'Education') && (
            <Button
              disabled={!hasAdditionalCostInsufficiency()}
              className="btn-block mt-1"
              color="warning"
              size="large"
              variant="outline-warning"
              onClick={() => handleIntiateMail('additionalCost')}
            >
              Clear Additional Cost
            </Button>
          )}
        </>
        : null}

      <Modal centered show={isEmailModalOne} onHide={() => setIsEmailModalOne(false)}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Initiate Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              emailAttachmentFiles: ''
            }}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
              try {
                setBtnLoader(true);
                let emailAttachments = document.getElementById('emailAttachmentFiles').files;
                console.log(emailAttachments);

                if (isEmptyArray(emailAttachments)) {
                  setIsEmailModalOne(false);
                  setBtnLoader(false);
                  sweetAlertHandler(bgvAlerts.noFilesPresent);
                } else {
                  let filesArray = [];

                  for (var attachment of emailAttachments) {
                    filesArray.push(attachment.name);
                  }

                  let payload = { data: { filesArray: filesArray } };
                  console.log('payload', payload);

                  const apiResponse = await defaultPostApi(dynamicUrl.convertToSignedUrl, payload);
                  console.log('Response', apiResponse);

                  if (apiResponse.Error) {
                    console.error(Error);
                    setStatus({ success: false });
                    setErrors({ submit: Error.message });
                    setSubmitting(false);
                    setBtnLoader(false);
                  } else {
                    if (!isEmptyArray(apiResponse.data)) {
                      let uploadParams = apiResponse.data;
                      console.log({ uploadParams });

                      // blob
                      for (let index = 0; index < uploadParams.length; index++) {
                        let blobField = document.getElementById('emailAttachmentFiles').files[index];
                        console.log({ blobField });

                        let fileData = uploadParams[index];

                        let result = await fetch(fileData, {
                          method: 'PUT',
                          body: blobField
                        });

                        console.log({ result });
                      }

                      let emailPayload = {
                        data: {
                          case_id: caseId,
                          user_component: component,
                          emailAttachments: apiResponse.data,
                          sub_component: subComponent,
                          insuff_type: currentInsuffType
                        }
                      };
                      console.log(emailPayload);
                      const sendEmailApiResponse = await defaultPostApi(dynamicUrl.clearInsufficiency, emailPayload);
                      console.log(sendEmailApiResponse);
                      if (sendEmailApiResponse.data === 200) {
                        // setIgnoreReduxData(true)
                        setLoadStatus((prev => !prev))
                        reloadData()

                        setStatus({ success: true });
                        setSubmitting(true);
                        setBtnLoader(false);
                        setEmailSent(true);
                      }
                    }
                  }
                }
              } catch (err) {
                console.error(err);
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
                setBtnLoader(false);
              } finally {
                setSubmitting(false);
                setBtnLoader(false);
              }
            }}
          >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
              <form noValidate onSubmit={handleSubmit}>
                <div className="form-group mb-4">
                  <input
                    className="form-control"
                    error={touched.emailAttachmentFiles && errors.emailAttachmentFiles}
                    label="emailAttachmentFiles"
                    name="emailAttachmentFiles"
                    id="emailAttachmentFiles"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.emailAttachmentFiles}
                    type="file"
                    multiple
                  />
                  {touched.emailAttachmentFiles && errors.emailAttachmentFiles && (
                    <small class="text-danger form-text">{errors.emailAttachmentFiles}</small>
                  )}
                </div>

                {errors.submit && (
                  <div className="form-group mb-4">
                    <Alert variant="danger">{errors.submit}</Alert>
                  </div>
                )}

                {errors.submit && (
                  <div className="form-group mb-4">
                    <Alert variant="danger">{errors.submit}</Alert>
                  </div>
                )}

                {emailSent && (
                  <div className="form-group mb-4">
                    <Alert variant="success">{MESSAGES.SUCCESS.EmailSentSuccessfully}</Alert>
                  </div>
                )}

                <Row>
                  <Col mt={2}>
                    {btnLoader ? (
                      <>
                        <Button className="btn-block" color="primary" size="large" variant="primary" disabled>
                          <span className="spinner-border spinner-border-sm mr-1" role="status" />
                          Loading...
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button className="btn-block" color="primary" disabled={isSubmitting} size="large" type="submit" variant="primary">
                          Initiate Email
                        </Button>
                      </>
                    )}
                  </Col>
                </Row>
              </form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ClearInsufficiency;